import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
export default function LinktreeIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Image src="/linktree-logo-icon.svg" alt="" aria-hidden="true" width={20} height={20} className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-object-contain tw-align-top" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}